import { Field } from 'formik'
import { useEffect } from 'react'
import { CustomAutocomplete, generateFilterGraphql } from 'src/admin/core'
import { useAppTranslation } from 'src/admin/core/hooks'
import { ProgramOwner } from '../../models'
import { useProgramOwners } from '../../hooks'

type Props = {
  defaultValue?: ProgramOwner
  disabled?: boolean
  ownerId?: number
  handleChange?: (value: ProgramOwner) => void
}

export const OwnerSelect = ({ defaultValue, disabled, ownerId, handleChange }: Props) => {
  const { results, getProgramOwners, loading } = useProgramOwners()

  const { label } = useAppTranslation()

  useEffect(() => {
    fetchProgramCompetitors(ownerId)
  }, [ownerId])

  const fetchProgramCompetitors = (ownerId: number | undefined) => {
    const customFilters = {
      and: [
        {
          name: { ...generateFilterGraphql('', 'contains') },
        },
      ],
    }

    getProgramOwners({ where: customFilters, skip: 0, take: 500 })
  }

  const handleChangeValue = (value: ProgramOwner) => {
    if (handleChange) {
      handleChange(value)
    }
  }

  return (
    <CustomAutocomplete
      keyValue={'id'}
      keyLabel={'name'}
      data={results.results}
      isLoading={loading}
      label={label('PROPIETARIO')}
      onChangeValue={handleChangeValue}
      disabled={disabled}
    />
  )
}
